export default __webpack_public_path__ + "static/media/test-drives.5d2f150f.jpg";